"use strict";

var _classCallCheck = require("/opt/build/repo/node_modules/@babel/runtime/helpers/classCallCheck.js");
var _createClass = require("/opt/build/repo/node_modules/@babel/runtime/helpers/createClass.js");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Connection = void 0;
var providers_1 = require("./providers");
var signer_1 = require("./signer");
/**
 * @param config Contains connection info details
 * @returns {Provider}
 */
function getProvider(config) {
  switch (config.type) {
    case undefined:
      return config;
    case 'JsonRpcProvider':
      return new providers_1.JsonRpcProvider(Object.assign({}, config.args));
    default:
      throw new Error("Unknown provider type ".concat(config.type));
  }
}
/**
 * @param config Contains connection info details
 * @returns {Signer}
 */
function getSigner(config) {
  switch (config.type) {
    case undefined:
      return config;
    case 'InMemorySigner':
      {
        return new signer_1.InMemorySigner(config.keyStore);
      }
    default:
      throw new Error("Unknown signer type ".concat(config.type));
  }
}
/**
 * Connects an account to a given network via a given provider
 */
var Connection = /*#__PURE__*/function () {
  function Connection(networkId, provider, signer, jsvmAccountId) {
    _classCallCheck(this, Connection);
    this.networkId = networkId;
    this.provider = provider;
    this.signer = signer;
    this.jsvmAccountId = jsvmAccountId;
  }
  /**
   * @param config Contains connection info details
   */
  _createClass(Connection, null, [{
    key: "fromConfig",
    value: function fromConfig(config) {
      var provider = getProvider(config.provider);
      var signer = getSigner(config.signer);
      return new Connection(config.networkId, provider, signer, config.jsvmAccountId);
    }
  }]);
  return Connection;
}();
exports.Connection = Connection;